/**
 * Toggle a value in a comma-separated filter string.
 * If the value already exists, it's removed; otherwise it's added.
 * @param {string} currentValue - The current comma-separated filter string
 * @param {string} toggleValue - The value to toggle
 * @returns {string} The new comma-separated filter string
 */
export function toggleMultiSelectFilter(currentValue, toggleValue) {
  const items = (currentValue || "").split(",")
  const existingIndex = items.findIndex((el) => el === toggleValue)
  if (existingIndex > -1) {
    items.splice(existingIndex, 1)
  } else {
    items.push(toggleValue)
  }
  return items.toString()
}
